/// <reference path="../global.d.ts" />

import flatpickr from "flatpickr";
import rangePlugin from 'flatpickr/dist/plugins/rangePlugin';

import { Spanish } from "flatpickr/dist/l10n/es.js"

import { Utils } from "../../include/utils";


export class SelectorFechas {

    utils = new Utils();

    intance_fechas: any = undefined;

    /** Objeto fecha */
    fechas_range: any = undefined;
    horai: any = undefined;
    horaf: any = undefined;

    /** Identificadores inputs flatpickr que reaccionan al cambio de fecha */
    id_fecha_i_flatpickr: string = 'fechai-recogida';
    id_fecha_f_flatpickr: string = 'fechaf-devolucion';

    /** Identificadores de inputs hidden que guardan el valor de las fechas seleccionadas */
    id_fecha_ini: string = 'fecha-ini';
    id_fecha_fin: string = 'fecha-fin';

    id_hora_ini: string = 'hora-ini';
    id_hora_fin: string = 'hora-fin';

    /** 
     * Guardamos el width inicial del selector 
     * por que al cambiar a hora, necesitamos volver al tamaño normal
     */
    width_selector: any;

    position_buscador: any;

    constructor() {
        // $(document).on('click', '.flatpickr-next-month', function () {
        //     //$('.dayContainer').show();
        // });
    }

    instanceDate() {
        let self = this;
        let $elemento_ini: any = $('#' + this.id_fecha_i_flatpickr);
        let $elemento_fin: any = $('#' + this.id_fecha_f_flatpickr);
        let $horaField = $('#' + this.id_hora_ini);
        let $horaFieldFin = $('#' + this.id_hora_fin);
        let $fecha_field_ini = $('#' + this.id_fecha_ini);
        let $fecha_field_fin = $('#' + this.id_fecha_fin);
        // Obtener la fecha actual
        let currentDate = new Date();
        currentDate.setHours(currentDate.getHours() + 1);
        currentDate.setHours(0, 0, 0, 0);
        let min_date = currentDate;

        let dates_ant: any = [];

        let lastFocusedInput: any = null;
        let onCloseExecuted = false;

        let optiones: any = {
            showMonths: 2,
            dateFormat: 'd/M/y',
            minDate: min_date,
            maxDate: null,
            mode: "range",
            ariaDateFormat: 'd/m/Y',
            disableMobile: false,
            time_24hr: false,
            position: "auto right",
            clickOpens: true,
            weekdays: (date: any, format: any) => {
                return date.toLocaleDateString("es", { weekday: "short" }).charAt(0);
            },
            onOpen: function (selectedDates: any, dateStr: any, instance: any) {
            },
            onValueUpdate: function (selectedDates: Date[], dateStr: any, instance: any) {

                if (selectedDates.length == 0) return false;
                let fecha_seleccionada_ini: string = '';
                let fecha_seleccionada_fin: string = '';

                let dates: any = [];

                /** Obtenemos las fechas en el formato requerrido dd/mm/yyyy */
                selectedDates.forEach((element: Date, index: number) => {
                    switch (index) {
                        case 0:
                            fecha_seleccionada_ini = element.getDate() + '/' + (element.getMonth() + 1) + '/' + element.getFullYear();
                            $elemento_ini.val(self.formatDateToCustomString(element, alk_lang));
                            $fecha_field_ini.val(fecha_seleccionada_ini);
                            dates[0] = element;
                            break;
                        case 1:
                            fecha_seleccionada_fin = element.getDate() + '/' + (element.getMonth() + 1) + '/' + element.getFullYear();
                            $elemento_fin.val(self.formatDateToCustomString(element, alk_lang));
                            $fecha_field_fin.val(fecha_seleccionada_fin);
                            dates[1] = element;
                            break;
                    }
                });

                if (self.isToday(selectedDates[0]) && lastFocusedInput === $elemento_ini[0]) {
                    setTimeout(() => {
                        instance.open();
                        self.openTimepickr(1, instance, $horaField);
                    });
                }

                if (lastFocusedInput == null) {
                    dates_ant = selectedDates;
                }
            },
            onDayCreate: function (dObj: any, dStr: any, fp: any, dayElem: any) {
                let id_pais = 1;

                switch (alk_lang) {
                    case 'es':
                        id_pais = 1;
                        break;
                    case 'en':
                        id_pais = 1;
                        break;
                    case 'es-mx':
                        id_pais = 29
                        break;
                    default:
                        break;
                }
                //if (fp.element.dataset.id_pais == undefined) return false
                // Solo agrega los estilos para las fechas festivas si es una búsqueda en Colombia.	
                const $dayElem = $(dayElem);
                let fecha = $dayElem.attr('aria-label');
                let festivos_ms = self.obtenerFestivos(id_pais);
                for (let festivo of festivos_ms) {
                    if (fecha == festivo.date) {
                        $dayElem.addClass('festivo').attr('title', festivo.name)
                        break
                    }
                }
            },
            onClose: function (selectedDates: any, dateStr: any, instance: any) {
                // Verificar si el input de fecha inicial está activo
                if (lastFocusedInput === $elemento_ini[0]) {

                    let fechaMayor_actual: any = new Date(Math.max(...selectedDates.map((date: any) => date.getTime())));
                    let fechaMayor_ant: any = new Date(Math.max(...dates_ant.map((date: any) => date.getTime())));

                    if (fechaMayor_ant < fechaMayor_actual) {
                        instance.setDate([selectedDates[1], null]);
                        lastFocusedInput = $elemento_fin[0];
                        instance.open();
                        dates_ant = selectedDates;
                        self.updatePositionSelector("#hora-fin");
                    }
                } else if (lastFocusedInput === $elemento_fin[0]) {
                    dates_ant = selectedDates;
                }
                self.closeTimepickr(instance, false)
            }
        };

        this.setLocale(optiones);

        optiones['plugins'] = [rangePlugin({ input: "#fechaf-devolucion" })];
        let intance_fecha_ini = flatpickr($elemento_ini.get(0), optiones);
        this.intance_fechas = intance_fecha_ini;
        let fecha = intance_fecha_ini;
        this.fechas_range = fecha;
        this.horai = $horaField;
        this.horaf = $horaFieldFin;

        $("#fechai-recogida").on("click", function (event) {
            event.preventDefault();
            event.stopPropagation();
            $('.flatpickr-calendar').css('opacity', '0');
            self.updatePositionSelector("#hora-ini");
            lastFocusedInput = $elemento_ini[0];
            self.closeTimepickr(self.intance_fechas, false);
        });

        // Manejar manualmente el clic en el input
        $("#fechaf-devolucion").on("click", function (event) {
            event.preventDefault();
            event.stopPropagation();
            $('.flatpickr-calendar').css('opacity', '0');
            self.updatePositionSelector("#hora-fin");
            lastFocusedInput = $elemento_fin[0];
            self.closeTimepickr(self.intance_fechas, false);
        });


        $horaField.on('click', function (event) {
            fecha.open();
            self.openTimepickr(1, fecha, $horaField);
        });

        $horaFieldFin.on('click', function (event) {
            fecha.open();
            self.openTimepickr(2, fecha, $horaFieldFin);
        });

        return fecha
    }

    /**
     * Método par alinear el selector de fechas y hora en una posicion especifica
     */
    updatePositionSelector(selector = '#fechaf-devolucion') {

        this.position_buscador = selector;
        const $elementoHijo = $(selector);
        const $padre = $elementoHijo.closest('.fecha-hora-container');
        const $flatpickrCalendar = $('.flatpickr-calendar');
        const posicionLeftDelPadre = $padre?.offset()?.left;
        const posicionTopDelPadre = $padre?.offset()?.top;
        const ancho = $padre.width();
        const alto = $padre.height();
        const anchoPantalla = window.innerWidth - 40;

        if (ancho && alto && posicionLeftDelPadre && posicionTopDelPadre) {
            let right = anchoPantalla - (posicionLeftDelPadre + ancho);
            let top = (posicionTopDelPadre + alto) + 15;

            $flatpickrCalendar.css('opacity', '0');
            // Aplicar transiciones CSS a todas las propiedades
            $flatpickrCalendar.css('transition', 'opacity 0.2s');
            // Esperar un pequeño intervalo antes de aplicar los estilos
            setTimeout(() => {
                $flatpickrCalendar.css({
                    'right': `${right}px`,
                    'top': `${top}px`,
                    'left': 'auto',
                    'opacity': '1',
                });
            }, 5); // Puedes ajustar el tiempo según tus necesidades

            // Eliminar transiciones después de que hayan terminado
            setTimeout(() => {
                $flatpickrCalendar.css('transition', '');
            }, 300); // Puedes ajustar el tiempo aquí según tus necesidades
        }
    }


    updateNamesInpustSEO() {
        // Asigna nombres a los campos de entrada para el año
        const yearInputs = document.querySelectorAll('.numInput.cur-year');
        yearInputs.forEach((input, index) => {
            input.setAttribute('name', `year_${index + 1}`);
        });

        // Asigna nombres a los campos de entrada para la hora
        const hourInput: any = document.querySelector('.numInput.flatpickr-hour');
        hourInput.setAttribute('name', 'hour');

        // Asigna nombres a los campos de entrada para el minuto
        const minuteInput: any = document.querySelector('.numInput.flatpickr-minute');
        minuteInput.setAttribute('name', 'minute');
    }

    formatDateToCustomString(date: Date, language: string) {
        const day = date.getDate();
        let monthNames;

        if (language === 'es' || language === 'es-mx') {
            monthNames = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
        } else if (language === 'en') {
            monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        }
        else {
            throw new Error('Unsupported language');
        }
        const monthIndex = date.getMonth();
        const year = date.getFullYear();

        const formattedDate = `${day}/${monthNames[monthIndex]}/${year}`;
        return formattedDate;
    }
    /**
     * Método para agreggar los lenguajes del selector
     * @param optiones 
     */
    setLocale(optiones: any) {
        if (alk_lang == 'es' || alk_lang === 'es-mx') {
            optiones.locale = {
                firstDayOfWeek: 1,
                weekdays: {
                    shorthand: ["D", "L", "M", "M", "J", "V", "S"]
                },
                months: {
                    shorthand: [
                        "Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"
                    ],
                    longhand: [
                        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
                    ],
                },
            };
        } else {
            optiones.locale = {
                firstDayOfWeek: 1,
                weekdays: {
                    shorthand: ["S", "M", "T", "W", "T", "F", "S"]
                }
            };
        }
    }


    closeTimepickr(instance: any, cerrarFlatpickr: any = true) {
        const $flatpickr_calendar = $(instance.calendarContainer)
        if (cerrarFlatpickr) {
            instance.close();
        }

        let $timepicker_content = $flatpickr_calendar.find('.timepicker-content')
        $timepicker_content.remove()
        $flatpickr_calendar.find('.flatpickr-months').show()
        $flatpickr_calendar.find('.flatpickr-innerContainer').show()
        $flatpickr_calendar.css('width', '800px')
        $('.flatpickr-days').css('width', '100%')


        $flatpickr_calendar.removeClass('time')
    }

    obtenerFestivos(idPais: any) {
        if (festivos == undefined) return [];
        if (festivos[idPais] == undefined) return [];
        let festivos_ms = []
        for (let i in festivos[idPais]) {
            let festivo = festivos[idPais][i]
            festivos_ms.push({
                name: festivo.nombFest
                , date: festivo.diaFest
            })
        }
        return festivos_ms;
    }


    openTimepickr(tipo: any, instance: any, $inputHora: any) {

        let self = this;
        const $flatpickr_calendar = $(instance.calendarContainer);


        this.width_selector = $flatpickr_calendar.width();

        let $timepicker_content = $flatpickr_calendar.find('.timepicker-content')

        $flatpickr_calendar.find('.flatpickr-months').hide();
        $flatpickr_calendar.find('.flatpickr-innerContainer').hide();
        $flatpickr_calendar.addClass('time');

        if (!$timepicker_content.length) {
            $timepicker_content = this.renderTimepickr(tipo);
            $flatpickr_calendar.append($timepicker_content);

            $timepicker_content.find('.volver').one('click', function () {
                $timepicker_content.remove()
                $flatpickr_calendar.find('.flatpickr-months').show()
                $flatpickr_calendar.find('.flatpickr-innerContainer').show()
                $flatpickr_calendar.removeClass('time')
            })

            $timepicker_content.find('.time').on('click', 'span:not(.disabled)', function (event) {
                event.stopPropagation()
                let $this = $(this),
                    hora_seleccionada = $this.text();
                $inputHora.val(hora_seleccionada);

                if (tipo == 1) {
                    self.horaf.val(self.horai.val())
                }
                self.closeTimepickr(instance)
            });
        }

        if (tipo == 1 && self.isToday(instance.selectedDates[0])) {
            const date = new Date();
            const hours = (date.getHours() + 1).toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const time = `${hours}:${minutes}`;

            let new_time: any;
            $timepicker_content.find('.time span').each(function () {
                const $this = $(this);
                if ($this.text() <= time) { $this.addClass('disabled'); }
                else {
                    if (new_time == null) new_time = $this.text();
                }
            });
            if ($inputHora.val() < time) $inputHora.val(new_time);
        }

        $timepicker_content.find(`.time span:contains("${$inputHora.val()}")`).addClass('selected')
        $timepicker_content.show();

        $('.flatpickr-calendar').css('width', '400px');

        if (tipo == 1) {
            self.updatePositionSelector("#hora-ini");
            //$('.flatpickr-calendar').css('left', '41%');        
        } else {
            self.updatePositionSelector("#hora-fin");
        }
    }


    renderTimepickr(tipo = 1) {
        return $(`<div class="timepicker-content">
                    <p class="timepicker-head bold">${tipo == 1 ? x_textos['553-0'] : x_textos['2236-1']}</p>
                    <div class="timepicker-cbody">
                        <div class="timepicker-body">
                            <p class="timepicker-title bold">${x_textos['554-0']}</p>
                            <div class="time">
                                <span>00:00</span>
                                <span>00:30</span>
                                <span>01:00</span>
                                <span>01:30</span>
                                <span>02:00</span>
                                <span>02:30</span>
                                <span>03:00</span>
                                <span>03:30</span>
                                <span>04:00</span>
                                <span>04:30</span>
                                <span>05:00</span>
                                <span>05:30</span>
                            </div>
                        </div>
                        <div class="timepicker-body">
                            <p class="timepicker-title bold">${x_textos['554-1']}</p>
                            <div class="time">
                                <span>06:00</span>
                                <span>06:30</span>
                                <span>07:00</span>
                                <span>07:30</span>
                                <span>08:00</span>
                                <span>08:30</span>
                                <span>09:00</span>
                                <span>09:30</span>
                                <span>10:00</span>
                                <span>10:30</span>
                                <span>11:00</span>
                                <span>11:30</span>
                                <span>12:00</span>
                                <span>12:30</span>
                                <span>13:00</span>
                                <span>13:30</span>
                                <span>14:00</span>
                                <span>14:30</span>
                                <span>15:00</span>
                                <span>15:30</span>
                                <span>16:00</span>
                                <span>16:30</span>
                                <span>17:00</span>
                                <span>17:30</span>
                            </div>
                        </div>
                        <div class="timepicker-body">
                            <p class="timepicker-title bold">${x_textos['555-0']}</p>
                            <div class="time">
                                <span>18:00</span>
                                <span>18:30</span>
                                <span>19:00</span>
                                <span>19:30</span>
                                <span>20:00</span>
                                <span>20:30</span>
                                <span>21:00</span>
                                <span>21:30</span>
                                <span>22:00</span>
                                <span>22:30</span>
                                <span>23:00</span>
                                <span>23:30</span>
                            </div>
                        </div>								
                    </div>							
                </div>`);
    }

    /**
     * Método para setear los valores iniciales 
     * Se almacenan en una cookie y se guardan en un atributo data de los inputs de fechas
     */
    setValoresInicialesSelector() {
        let fecha_ini = new Date($('#' + this.id_fecha_i_flatpickr).data('val').replace(/-/g, "/"));
        let fecha_fin = new Date($('#' + this.id_fecha_f_flatpickr).data('val').replace(/-/g, "/"));
        let $elemento_ini: any = $('#' + this.id_fecha_i_flatpickr);
        let $elemento_fin: any = $('#' + this.id_fecha_f_flatpickr);
        let fecha_actual = new Date();

        if (fecha_ini < fecha_actual) {
            this.utils.sendMsjModal(x_textos["2349-1"], x_textos['2349-0'], false, "Buscar", () => { 
                window.location.href = '/'; // Redirige a la página de inicio
            },undefined, false,false,"bg-warning");
        }

        this.intance_fechas.setDate([fecha_ini, fecha_fin], true);

        $elemento_ini.val(this.formatDateToCustomString(fecha_ini, alk_lang));
        $elemento_fin.val(this.formatDateToCustomString(fecha_fin, alk_lang));
    }

    isToday(date: Date) {
        const today = new Date();
        return (
            date.getDate() === today.getDate() &&
            date.getMonth() === today.getMonth() &&
            date.getFullYear() === today.getFullYear()
        );
    }
}